import { useEffect, useReducer } from "react";
import { reducer, actions, initialState } from "./reducer";
import { callApi } from "api";
export const useHotels = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    callApi(
      "/api/hotels/get/",
      "GET",
      {},
      {
        REQUEST: actions.GET_DATA_REQUEST,
        SUCCESS: actions.GET_DATA_SUCCESS,
        FAILURE: actions.GET_DATA_FAILURE,
      },
      dispatch,
      false
    );
  }, []);
  return [state.getData];
};
